import React, { useState, useEffect, useRef } from "react";
import "./viewquery.scss";
import Sidebar from "../Sidebar";
import { querydetailAction, postqueryAction, assigneeListAction, assignQueryAction } from "../../actions/queryAction";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom'
import { decode } from "base-64";
import { useNavigate } from "react-router-dom";
import { notify } from '../../services/notification';
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";

function ViewQuery() {
  const [state, setDataState] = useState({
    querydetail: [],
    Resolutions: "",
    query: "",
    category: '',
    user_name: '',
    description: '',
    mobile_number: '',
    pincode: '',
    district: '',
    state_name: '',
    email: '',
    created_at_date: '',
    created_at_time: '',
    attachment: '',
    resolution: "",
    status: "",
    is_deleted: "",
    assigned_to: "",
    assigned_to_name: "",
    persona: "",
    user_id: "",
    user_account_no: "",
    user_approval_status: "",
    aps_code: "",
    aps_name: "",
    area_head: "",
    zonal_manager: "",
  });

  const [assigneeList, setAssigneeList] = useState([]);

  useEffect(() => {
    queryDetail();
    fetchAssigneeList();
  }, []);

  // Resolve assigned_to name to ID once assigneeList is loaded
  useEffect(() => {
    if (assigneeList.length > 0 && state.assigned_to) {
      const matchById = assigneeList.find(a => String(a.id) === String(state.assigned_to));
      if (!matchById) {
        const matchByName = assigneeList.find(a => a.name === state.assigned_to);
        if (matchByName) {
          setDataState(prev => ({ ...prev, assigned_to: matchByName.id, assigned_to_name: matchByName.name }));
        }
      }
    }
  }, [assigneeList]);

  async function fetchAssigneeList() {
    const response = await dispatch(assigneeListAction());
    if (response?.status === 200 || response?.status === 201) {
      setAssigneeList(response?.data?.data.results || []);
    }
  }

  const [attachmentdata, setattachmentdata] = useState([]);
  const [textCount, setTextCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const { isSidebarOpen, toggleSidebar } = useMobileView();


  function updateChars() {
    const text = document.getElementById("Resolutions").value;
    setTextCount(text.length);
  }
  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({ ...state, [evt.target.name]: value.replace(/^ +/gm, ''), });
    if (evt.target.name === "Resolutions") {
      updateChars();
    }
  };

  const handleAssignedToChange = async (evt) => {
    const newAssignedTo = evt.target.value;
    const previousAssignedTo = state.assigned_to;
    const previousAssignedToName = state.assigned_to_name;
    const selectedAssignee = assigneeList.find(a => String(a.id) === String(newAssignedTo));
    const newName = selectedAssignee?.name || newAssignedTo;

    setDataState(prev => ({ ...prev, assigned_to: newAssignedTo, assigned_to_name: newName }));

    let response = await dispatch(assignQueryAction(newAssignedTo, decodeid));
    if (response != null) {
      notify.success( response?.data?.data || "Assigned To updated successfully.");
    } else {
      setDataState(prev => ({ ...prev, assigned_to: previousAssignedTo, assigned_to_name: previousAssignedToName }));
      notify.error("Failed to update Assigned To.");
    }
  };

  const { id } = useParams()
  const decodeid = decode(id)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function queryDetail() {
    setLoader(true);
    let response = await dispatch(querydetailAction(decodeid));
    if (response == 200 || response != null) {
      setLoader(false);
      const data = response.data.data[0];
      setDataState({
        ...state,
        querydetail: response.data,
        query: data.query,
        category: data.category,
        user_name: data?.user_name,
        description: data.description,
        mobile_number: data.mobile_number,
        pincode: data.pincode,
        district: data?.district || "",
        state_name: data?.state || "",
        email: data.email,
        created_at_date: data.created_at_date,
        created_at_time: data.created_at_time,
        resolution: data?.resolution,
        status: data.status,
        is_deleted: data.is_deleted,
        assigned_to: data?.assigned_to?.id || "",
        assigned_to_name: data?.assigned_to?.name || "",
        persona: data?.user_type || "",
        user_id: data?.pgm || "",
        user_account_no: data?.account_number || "",
        user_approval_status: data?.pgm_status || "",
        aps_code: data?.aps_code || "",
        aps_name: data?.aps_name || "",
        area_head: data?.area_head_email || "",
        zonal_manager: data?.zonal_manager || "",
      });
      setattachmentdata(data.attachment)
    }
    else if (response === undefined) {
      setLoader(false);
    }
  }

  const oncancel = () => {
    window.scroll(0, 0)
    navigate(`/query`);
  }

  const handleDownload = (attachurl) => {
    const link = document.createElement("a");
    link.href = attachurl;
    link.download = "myfile.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [Error, setError] = useState({
    resolutionError: "",
  });

  let validateForm = () => {
    let formIsValid = true;
    if (state.Resolutions === '') {
      formIsValid = false;
      setError({ resolutionError: "" });
    }
    else {
      setError(" ");
    }
    return formIsValid;
  };

  const errorMessageRef = useRef(null);

  useEffect(() => {
    if (Error.resolutionError && errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [Error]);


  const onClose = async () => {
    setLoader(true);
    if (validateForm()) {
      var formData = new FormData();

      formData.append("status", "CLOSED");
      formData.append("resolution", state.Resolutions);
      formData.append("query_id", decodeid);

      let response = await dispatch(postqueryAction(formData))
      if (response == 200 || response != null) {
        setLoader(false);
        notify.success("Query has been marked closed.")
        navigate('/query')
        window.scroll(0, 0)
      }
      else if (response === undefined) {
        setLoader(false);
      }
    }
  }

  const renderReadOnlyField = (label, value) => (
    <div>
      <div className="Label_name">
        <label>{label}</label>
        <input type="text"
          className="input_field_query"
          value={value || ''}
          title={value || ''}
          readOnly />
      </div>
    </div>
  );

  return (
    <div className="Query_Containers">
      <div className="Query_Containers_right">
        <Header title="View Query" />
        {loader ? <Loader /> :
          <div className="PgmSpecial_Texts">
            <div className="TextConatinerDetails" >
              {/* Left Side - Query Details */}
              <div className="TextContainerLeft">
                <h3 className="section-heading">Query Details</h3>
                {renderReadOnlyField("Query ID", decodeid)}
                {renderReadOnlyField("Query Category", state.category)}
                {renderReadOnlyField("Query Title", state.query)}
                <div>
                  <div className="Label_name">
                    <label>Query Description</label>
                    <textarea type="text" className="textareaInputbox" name="description"
                      value={state.description}
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <div className="Label_name">
                    <label>Assigned To</label>
                    {state?.status?.toLowerCase() === "open" ? (
                      <select
                        name="assigned_to"
                        className="input_field_query"
                        value={state.assigned_to}
                        onChange={handleAssignedToChange}
                      >
                        <option value="">Select Assignee</option>
                        {assigneeList.map((assignee) => (
                          <option key={assignee.id} value={assignee.id}>{assignee.name}</option>
                        ))}
                      </select>
                    ) : (
                      <input type="text"
                        name="assigned_to"
                        className="input_field_query"
                        value={state.assigned_to_name}
                        readOnly />
                    )}
                  </div>
                </div>
                <div>
                  <div className="Label_name">
                    <label ref={errorMessageRef}>Resolution{state.status === "OPEN" ? <span style={{ color: "red" }}>*</span> : ""}</label>

                    {state.resolution === "" || state.resolution == null ?
                      <>
                        <textarea type="text" className="textareaInputbox"
                          name="Resolutions"
                          id="Resolutions"
                          pattern="^[a-zA-Z][\sa-zA-Z]*"
                          value={state.Resolutions}
                          onChange={handleChange}
                          rows={10}
                          cols={50}
                          maxLength={300} />
                        <span className='textcount-description-viewquery montserrat-font'>{textCount}/300</span>
                      </>
                      :
                      <textarea type="text" className="textareaInputbox"
                        name="resolution"
                        id="resolution"
                        pattern="^[a-zA-Z][\sa-zA-Z]*"
                        value={state.resolution}
                        readOnly />
                    }
                    <span className="ErrorMessage  montserrat-font">{Error.resolutionError}</span>
                  </div>
                </div>
                <div>
                  <div className="Label_name">
                    <label>Attachments</label>
                  </div>
                  {attachmentdata?.map((attach, i) =>
                    <React.Fragment key={i}>
                      <div className="file_name">
                        {attach.attachment?.endsWith('.jpg') || attach.attachment?.endsWith('.png') || attach.attachment?.endsWith('.webp') ?
                          <span >
                            <img
                              src={attach.attachment}
                              alt="preview"
                              height="100px"
                              width="100px"
                            />
                          </span>
                          : <label>{attach.attachment.substring(attach.attachment.lastIndexOf("/") + 1)}</label>}
                      </div>
                      <div>
                        <span className="download_btn"
                          onClick={() => {
                            handleDownload(attach.attachment);
                          }}
                        > Download</span>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>

              {/* Right Side - User Details */}
              <div className="TextContainerRight">
                <h3 className="section-heading">User Details</h3>
                {renderReadOnlyField("Persona", state.persona)}
                {renderReadOnlyField("User ID", state.user_id)}
                {renderReadOnlyField("User Account No", state.user_account_no)}
                {renderReadOnlyField("User Mobile No", state.mobile_number)}
                {renderReadOnlyField("User Name", state.user_name)}
                {renderReadOnlyField("User Approval Status", state.user_approval_status)}
                {/* {renderReadOnlyField("Email Id", state.email)} */}
                {renderReadOnlyField("Pincode", state.pincode)}
                {renderReadOnlyField("District", state.district)}
                {renderReadOnlyField("State", state.state_name)}

                <h3 className="section-heading section-heading-gap">Hierarchy Details</h3>
                {renderReadOnlyField("APS Code", state.aps_code)}
                {renderReadOnlyField("APS Name", state.aps_name, state.aps_name)}
                {renderReadOnlyField("Area Head", state.area_head)}
                {/* {renderReadOnlyField("Zonal Manager", state.zonal_manager)} */}

                <h3 className="section-heading section-heading-gap">Ticket Info</h3>
                <div>
                  <div className="Label_name">
                    <label>Created Date</label>
                    <input type="date"
                      name="created_at_date"
                      value={state.created_at_date}
                      className="input_field_query"
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <div className="Label_name">
                    <label>Created Time</label>
                    <input type="time"
                      name="created_at_time"
                      value={state.created_at_time}
                      className="input_field_query"
                      readOnly
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="pgmbuttons">
              <button className="view-query-button-mark-close"
                type="button" onClick={oncancel}
              >Close</button>
              {state.status !== "CLOSED" && !state.is_deleted &&
                <button className="query_buttonclose"
                  disabled={state.Resolutions === ""}
                  onClick={onClose} >Mark Closed</button>}
            </div>
          </div>
        }
      </div>
    </div>
  );
}
export default ViewQuery;
